module.exports = __webpack_public_path__ + "img/mongodb-soft.0e23481b.png";